import { getAppConfig } from 'aster-foundation/core/astercore/appConfig/redux/actions';
import { getProductDetails, getFBTProductsBySearch } from 'aster-foundation/core/epharmacy/Product/redux/action';
import { getCartFillers, getCartDetails } from 'aster-foundation/core/epharmacy/Cart/redux/actions';
import withAnalytics from '@common/Component/Hoc/WithAnalytics';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import {
  BUNDLE_DEAL_PDP,
  BUNDLE_DEAL_PDP_UPDATED,
  IC_GREEN_TICK,
  IC_HEART,
  IC_ORIGINAL,
  IC_SECURE_PAYMENT,
  IC_TRUSTED_SHIPPING,
  PRODUCT_CARD_DEFAULT,
} from '@common/Assets/images';
import CommonMeta from '@common/Component/CommonMeta/CommonMeta';
import { sendAdjustViewContentPharmacyEvent } from '@common/Utility/Adjust';
import {
  MAX_QTY_ADD_TO_CART_PER_ORDER,
  destructureAndGetCurrentCartItemsList,
  errorHandlingEpharmacy,
  getConfigurationActiveValueByName,
  MIN_MOBILE_WIDTH,
  getProductPath,
  checkIfCurrentRegionIsSaudi
} from '@common/Utility/common-utils';
import {
  ADJUST_EVENT_TOKENS,
  ASTER_PRODUCT_AVAILABILITY,
  ASTER_PRODUCT_TYPES,
  ONLINE_PHARMACY_ROUTE,
  PRODUCTS_DETAILS_PAGE,
  ONLINE_PHARMACY_TITLE,
  ONE_ASTER_CATEGORY,
  PRODUCT_REVIEW_FLAG,
  PRODUCT_RATINGS_FLAG,
  FBT_SECTION_FLAG,
  PDP_UPSELLING_FLAG,
  SCHEDULED_EXPRESS_FLAG,
  AE_GLOBAL,
  FLAGSMITH_KEYS,
  CART_TYPES,
  HOME,
} from '@common/Utility/constants';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { BreadcrumbControl, ButtonBase } from '@common/Component/Forms';
import HeaderBelow from '@common/Component/HeaderBelow/HeaderBelow';
import Loader from '@common/Component/Loader/Loader';
import RightSideBar from '@common/Component/RightSideBar/RightSideBar';
import { getPage, PAGE, PAGE_NAME } from '@common/Constants/analytics';
import { flagsmith } from '@common/Lib/Flagsmith';
import { EventEmitter } from '@common/Utility/eventEmitter';
import StarRatingNumberOnly from '@common/Component/StarRatingNumberOnly/StarRatingNumberOnly';
import AddToCart from '../Cart/AddToCart';
import { dataLayerSendEpharmacyPageViewEvent, dataLayerSendEvent,getCurrencyFromRegion,getProductItemObject, getProductItemObjectEventFillersSelect } from '../EpharmacyAnalytics';
import DeliveryDetails from './PDPComponents/DeliveryDetails';
import OfferTimeCounter from './PDPComponents/OfferTimeCounter';
import ProductHighLights from './PDPComponents/ProductHighLights';
import ProductOverview from './PDPComponents/ProductOverview';
import ProductShowCase from './PDPComponents/ProductShowCase';
import ReturnableRibbon from './PDPComponents/ReturnableRibbon';
import ScrolledCartDetails from './PDPComponents/ScrolledCartDetails';
import ProductDetailsStyled from './ProductDetailsStyled';
import ProductReviews from './ProductReviewComponents/ProductReviews';
import FBTSection from './PDPComponents/FBTSection';
import FBTUpsellingSection from './PDPComponents/FBTUpsellingSection';
import CartFillerMiniCart from '../MyCart/CartFillerMiniCart';
import { FBTStyled } from './PDPComponents/FBTStyled';
import OpticalVariant from './PDPComponents/Variants/OpticalVariant';
import { setProductItemQtyMultiple } from './redux/reducer';
import { setTotalQtyData } from 'Epharmacy/MyCart/redux/reducer';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import DownloadAppSection from './PDPComponents/DownloadAppSection/DownloadAppSection';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../i18n';

const ProductOffers = dynamic(() => import('./PDPComponents/ProductOffers'));
const ProductBottom = dynamic(() => import('./ProductBottom'));
const ProductNotFound = dynamic(() => import('./ProductNotFound'));
const BundleOffer = dynamic(() => import('./PDPComponents/BundleOffer'));

const ProductDetails = (props) => {
  const { productQuery, productDetails, homePageSeoData, referrerPage, isFirstCalled, setIsFirstCalled, setLoading } =
    props;
  const isOpticalProduct = productDetails?.productType === 'Optics';
  const productHasVariants = productDetails?.extensionAttributes?.variantData?.length > 0;
  const dispatch = useDispatch();
  const router = useRouter();
  const generateURL = useNavigationURL();
  const ratingsBottomRef = useRef(null);
  const scrollRef = useRef(null);
  const t = useTranslation();

  const ae_common_api_actions = flagsmith.getValue(FLAGSMITH_KEYS?.COMMON_API_ACTION, { json: true });
  const enableXUserVcpId = ae_common_api_actions?.xUserVcpId || false;

  const routerValue = router?.query?.product;
  const pageId = router?.query?.product[1]?.split('?')?.[0];
  const queryLength = productQuery?.length;
  const id = productQuery ? productQuery[queryLength - 1] : routerValue[routerValue.length - 1];
  const categoryId = router?.query?.categoryId;
  const isFromRecentSearch = router?.query?.isFromRecentSearch || false;
  const urlKey = routerValue;
  const [selectedSPHSkus, setSelectedSPHSkus] = useState(null);
  const pageViewEventFired = useRef();
  const ae_web_scheduled_express = flagsmith.getValue(SCHEDULED_EXPRESS_FLAG, { json: true });
  const pomFlag = flagsmith.getValue(FLAGSMITH_KEYS.POM_PRODUCT_FLAG, { json: true });
  const isSheduledExpress = ae_web_scheduled_express?.isSheduledExpress;
  const showSheduledDeliveryMessage = ae_web_scheduled_express?.showSheduledDeliveryMessage;
  const pdpPomText= pomFlag?.pdp?.text;
  const reducerItems = useSelector((state) => state?.app?.pdpReducer?.items);
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  const getVarientInfo = (variantId, productInfo) => {
    const variants = productInfo?.extensionAttributes?.variantData?.[0]?.variants;
    return variants?.[variantId]?.productData;
  };

  const getOpticsData = (productInfo) => {
    let opticsPrice = null;
    let opticsLoyalty = null;
    let opticsAvailableStock = null;
    let opticsOutOfStock = false;
    let opticsLowStock = false;
    let opticsSpecialPrice = null;
    let priceBreakup = null;
    let variantDelivery = null;
    let variantDeliveryV2 = null;
    let variantDeliveredBy = null;
    let variantDeliveredByV2 = null;
    let variantOrderWithin = null;
    let variantDeliveryTime = null;
    if (selectedSPHSkus?.leftOrDefault || selectedSPHSkus?.right) {
      const leftOrDefaultVariant = getVarientInfo(selectedSPHSkus?.leftOrDefault?.id, productInfo);
      opticsPrice = leftOrDefaultVariant?.price || 0;
      opticsLoyalty = leftOrDefaultVariant?.loyaltyPoints;
      opticsAvailableStock = leftOrDefaultVariant?.availableStock;
      opticsOutOfStock = opticsOutOfStock || leftOrDefaultVariant?.outOfStock;
      opticsLowStock = opticsLowStock || leftOrDefaultVariant?.lowStock;
      opticsSpecialPrice = leftOrDefaultVariant?.specialPrice || 0;
      variantDeliveryTime = leftOrDefaultVariant?.expectedDeliveryInMillis;
      variantDelivery = leftOrDefaultVariant?.deliveryText;
      variantDeliveryV2 = leftOrDefaultVariant?.deliveryTextV2;
      variantDeliveredBy = leftOrDefaultVariant?.deliverBy;
      variantDeliveredByV2 = leftOrDefaultVariant?.deliverByV2;
      variantOrderWithin = leftOrDefaultVariant?.orderWithin;

      let rightVariant;
      if (selectedSPHSkus?.isDifferentSPH && selectedSPHSkus?.right) {
        rightVariant = getVarientInfo(selectedSPHSkus?.right?.id, productInfo);
        opticsPrice = (Number(opticsPrice) + Number(rightVariant?.price)).toString();
        opticsLoyalty = Number(opticsLoyalty ?? 0) + Number(rightVariant?.loyaltyPoints);
        opticsAvailableStock = leftOrDefaultVariant?.availableStock;
        opticsOutOfStock = opticsOutOfStock || rightVariant?.outOfStock;
        opticsLowStock = opticsLowStock || rightVariant?.lowStock;
        const defaultRightVariantSP = Number(opticsSpecialPrice) > 0 ? rightVariant?.price : 0;
        const defaultLeftVariantSP = Number(opticsSpecialPrice) === 0 ? rightVariant?.specialPrice ? leftOrDefaultVariant?.price : 0 : 0;
        opticsSpecialPrice = (Number(opticsSpecialPrice || defaultLeftVariantSP) + Number(rightVariant?.specialPrice || defaultRightVariantSP)).toString();
        if (variantDeliveryTime < rightVariant?.expectedDeliveryInMillis || !variantDeliveryTime) {
          variantDeliveryTime = rightVariant?.expectedDeliveryInMillis;
          variantDelivery = rightVariant?.deliveryText;
          variantDeliveryV2 = rightVariant?.deliveryTextV2;
          variantDeliveredBy = rightVariant?.deliverBy;
          variantDeliveredByV2 = rightVariant?.deliverByV2;
          variantOrderWithin = rightVariant?.orderWithin;
        }
      }

      if (leftOrDefaultVariant && rightVariant) {
        priceBreakup = `${productInfo?.currency} ${leftOrDefaultVariant?.specialPrice} + ${productInfo?.currency} ${rightVariant?.specialPrice}`;
      }
    } else {
      const defaultVariant = getVarientInfo(productInfo?.defaultVariant, productInfo);
      opticsPrice = selectedSPHSkus?.isDifferentSPH
        ? (Number(defaultVariant?.price) * 2).toString()
        : defaultVariant?.price;
      opticsLoyalty = selectedSPHSkus?.isDifferentSPH
        ? Number(defaultVariant?.loyaltyPoints) * 2
        : defaultVariant?.loyaltyPoints;
      opticsAvailableStock = defaultVariant?.availableStock;
      opticsOutOfStock = defaultVariant?.outOfStock;
      opticsLowStock = defaultVariant?.lowStock;
      opticsSpecialPrice = selectedSPHSkus?.isDifferentSPH
        ? (Number(defaultVariant?.specialPrice || 0) * 2).toString()
        : defaultVariant?.specialPrice;
      variantDeliveryTime = defaultVariant?.expectedDeliveryInMillis;
      variantDelivery = defaultVariant?.deliveryText;
      variantDeliveryV2 = defaultVariant?.deliveryTextV2;
      variantDeliveredBy = defaultVariant?.deliverBy;
      variantDeliveredByV2 = defaultVariant?.deliverByV2;
      variantOrderWithin = defaultVariant?.orderWithin;
    }

    return {
      price: opticsPrice,
      loyaltyPoints: opticsLoyalty,
      availableStock: opticsAvailableStock,
      outOfStock: opticsOutOfStock,
      lowStock: opticsLowStock,
      specialPrice: opticsSpecialPrice,
      priceBreakup,
      deliveryTime: variantDeliveryTime,
      deliveryText: variantDelivery,
      deliveryTextV2: variantDeliveryV2,
      deliverBy: variantDeliveredBy,
      deliverByV2: variantDeliveredByV2,
      orderWithin: variantOrderWithin,
    };
  };

  let variantProductData = isOpticalProduct ? getOpticsData(productDetails) : {};
  variantProductData = { ...productDetails, ...variantProductData };
  const [detailsData, setDetailsData] = React.useState(variantProductData);
  const [BreadcrumsData, setBreadcrumsData] = React.useState();
  const [customAttribute, setCustomAttribute] = useState({});
  const [selectedCartItem, setSelectedCartItem] = useState(0);
  const [isReviewsEnable, setIsReviewsEnable] = useState();
  const [isRatingsEnable, setIsRatingsEnable] = useState();
  const [isFBTEnabled, setIsFBTEnabled] = useState('false');
  const [showUpselling, setShowUpselling] = useState(false);
  const [cartFillers, setCartfillers] = useState([]);
  const [pdpUpSellingFlag, setPdpUpSellingFlag] = useState();
  const [fbtSkuId, setFBTSkuId] = useState();
  const [fbtProductId, setFbtProductId] = useState('');
  const [showVideo, setShowVideo] = useState(false);
  const [fbtProducts, setFbtProducts] = useState([]);
  const [selectedMediaID, setSelectedMediaId] = useState('');
  const [cartProperties, setCartProperties] = useState({
    itemFiller_sku: [],
    cartItem_sku: [],
    cartItem_qty: [],
    cartItem_Price: [],
  });
  const [upsellingqty, setUpsellingqty] = useState(0);
  const [windowWidth, setWindowWidth] = useState();
  const [fbt_isStock, setFbt_isStock] = useState(false);
  const [fbtshow3, setFbtshow3] = useState(false);
  const [upsellingprice, setUpsellingprice] = useState('');
  const [pdp_qty, setPdp_qty] = useState(0);
  const [pdp_price, setPdp_price] = useState(0);
  const [fbt_disabled, setFbt_disabled] = useState(false);
  const [deleteProductID, setDeleteProductID] = useState([]);
  const [skuForAddToCart, setSkuForAddToCart] = React.useState(
    router?.asPath?.includes('sku-') ? id : detailsData?.sku,
  );
  const [errors, setErrors] = useState({});
  const [currentLang, setCurrentLanguage] = React.useState('');
  const appConfig = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const detailLoading = useSelector((state) => state?.epharmacy?.getProductDetailsWebUrlKeyOnly?.isFetching);
  const loadingProductDetails = useSelector((state) => state?.epharmacy?.getProductDetails?.isFetching);
  const loadingProductDetailsWeb = useSelector((state) => state?.epharmacy?.getProductDetails?.isFetching);
  const deleteLoader = useSelector((state) => state?.epharmacy?.removeItemFromCart?.isFetching);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const cartDataInitial = useSelector((state) => state?.epharmacy?.getCartDetails?.data);

  const userLocation = useSelector((state) => state?.app?.userLocationReducer);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const userLocationLoading = useSelector((state) => state?.app?.userLocationReducer?.isFetching);
  const getCartV2Data = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);
  const zoneData = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const userZoneData = useSelector((state) => state?.epharmacy?.updateUserZone?.data?.additionalInfo);

  const cartFillerLen = cartFillers?.length;
  const getGuestLoginMemo = React.useMemo(() => guestLogin?.accessToken, [guestLogin?.accessToken]);
  const commonAnalyticsProps = useRef();

  const fetchCartInfo = () => {
    const { page } = getPage(router?.asPath);
    const params = {
      cartId: getCartV2Data?.cart_id,
      "cart_type": CART_TYPES.AE,
      "merge_shipment": false,
      page,
    };
    if(enableXUserVcpId){
      params.userId = userLogin?.id
    }
    if (userZoneData) {
      params.zones = encodeURIComponent(JSON.stringify(userZoneData));
    }
    if (!checkIfCurrentRegionIsSaudi()) {
      dispatch(
        getCartDetails({
          param: params,
          onSuccess: (response) => {
            getCartFillersData(response);
            if (response?.delivery_groups) {
              dispatch(setProductItemQtyMultiple(destructureAndGetCurrentCartItemsList(response)));
            }
            dispatch(setTotalQtyData(response?.total_quantity));
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, commonAnalyticsProps?.current?.screenName, commonAnalyticsProps?.current?.pageType);
          },
        }),
      );
    }
  };

  React.useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  useEffect(() => {
    fetchCartInfo();
  }, [productDetails, detailsData, zoneData]);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    if (!selectedSPHSkus) return;

    const opticDetails = getOpticsData(detailsData);
    setDetailsData({ ...detailsData, ...opticDetails });
    setErrors({
      ...errors,
      sph: {},
    });
  }, [selectedSPHSkus]);

  const navigationUrl = productDetails?.brandDetails?.navigationUrl;

  useEffect(() => {
    const filteredItems = reducerItems?.filter((item) => fbtSkuId?.includes(item?.item_id));
    const prices = filteredItems?.map((item) => parseFloat(item?.price) || 0);
    const qty = filteredItems?.map((item) => item?.qty);
    const totalQuantity = qty?.reduce((total, qty) => total + qty, 0);
    const totalPrice = prices?.reduce((total, price, index) => total + price * qty[index], 0);

    setPdp_qty(totalQuantity || 0);
    setPdp_price(parseFloat(Number(totalPrice?.toFixed(2))) || 0);
  }, [fbtSkuId, reducerItems]);

  React.useEffect(() => {
    const bredArr = [];
    if(web_feature_flaging?.isBreadcrumbAEDisabled)
      bredArr.push({ text: t('Breadcrumb.home'), link: generateURL(ONLINE_PHARMACY_ROUTE) });
    else
      bredArr.push({ text: t('Breadcrumb.home'), link: generateURL(HOME) }, { text: t('Home.onlinePharmacy'), link: generateURL(ONLINE_PHARMACY_ROUTE) });
    if (detailsData?.categoryPath) {
      detailsData?.categoryPath.map((item, index) => {
        if (index < 2) {
          return bredArr.push({
            text: item?.label,
            link: generateURL(`${ONLINE_PHARMACY_ROUTE}/searchresult`),
            query: `category=${item?.id}&name=${item?.label}`,
          });
        }
        return '';
      });
    }
    setBreadcrumsData(bredArr);
    if (detailsData?.customAttribute) {
      const attr = {};
      detailsData?.customAttribute?.forEach((element) => {
        attr[element?.attributeCode] = element.value;
      });
      setCustomAttribute(attr);
    }
  }, [detailsData]);

  const getCartFillersData = (response) => {
    const skus = response?.delivery_groups?.flatMap(delivery => delivery.items.map(item => item.sku));
    if (zoneData?.length > 0 && skus.length > 0) {
      const params = {
        skus: skus?.length > 0 ? skus.join(',') : productDetails?.sku?.join(','),
        zone: zoneData.join(','),
      };
      dispatch(
        getCartFillers({
          params,
          onSuccess: (response) => {
            setCartfillers(response);
            if (Array.isArray(response)) {
              setCartProperties((prevState) => ({
                ...prevState,
                itemFiller_sku: response.map((item) => item?.sku) || [],
              }));
            }
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, commonAnalyticsProps?.current?.screenName, commonAnalyticsProps?.current?.pageType);
          },
        }),
      );
    }
  };

  useEffect(() => {
    let qty = 0;
    let price = 0;
    let currentCartItem = null;

    if (isOpticalProduct) {
      if (selectedSPHSkus?.isDifferentSPH && selectedSPHSkus?.leftOrDefault?.sku !== selectedSPHSkus?.right?.sku) {
        const rightCartItem = getCartV2Data?.delivery_groups?.flatMap(group => group?.items?.filter(
          (cartItem) => cartItem?.sku === selectedSPHSkus?.right?.sku,
        ));
        const leftCartItem = getCartV2Data?.delivery_groups?.flatMap(group => group?.items?.filter(
          (cartItem) => cartItem?.sku === selectedSPHSkus?.leftOrDefault?.sku,
        ));
        // eslint-disable-next-line no-unsafe-optional-chaining
        qty = (rightCartItem?.[0]?.qty || 0) + (leftCartItem?.[0]?.qty || 0);
        price =
          (rightCartItem?.[0]?.sale_price || 0) * (rightCartItem?.[0]?.qty || 0) +
          (leftCartItem?.[0]?.sale_price || 0) * (leftCartItem?.[0]?.qty || 0);
      } else {
        currentCartItem = getCartV2Data?.delivery_groups?.flatMap(group => group?.items?.filter(
          (cartItem) => cartItem?.sku === selectedSPHSkus?.leftOrDefault?.sku,
        ));
        qty = currentCartItem?.[0]?.qty || 0;
        price = (currentCartItem?.[0]?.sale_price || 0) * qty;
      }
    } else {
      currentCartItem = reducerItems?.filter((item) => item?.item_id === detailsData?.sku);

      if (currentCartItem?.length > 0) {
        qty = currentCartItem?.[0]?.qty || 0;
        price = (detailsData?.specialPrice || detailsData?.price || 0) * qty;
      }
    }

    setSelectedCartItem({ qty, price });
  }, [getCartV2Data, JSON.stringify(reducerItems)]);

  React.useEffect(() => {
    if ((!appConfig || typeof appConfig === 'undefined') && guestLogin?.accessToken) {
      dispatch(
        getAppConfig({
          onSuccess: () => {},
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, commonAnalyticsProps?.current?.screenName, commonAnalyticsProps?.current?.pageType);
          },
        }),
      );
    }
    const isViewItemCalled = localStorage.getItem('is_view_item_called');
    if (isFirstCalled && detailsData && isViewItemCalled !== 'true') {
      let qty = 0;
      const currentCartItem = getCartV2Data?.itemsToCart?.filter((cartItem) => cartItem?.sku === detailsData?.sku);
      if (currentCartItem?.length > 0) {
        qty = currentCartItem?.[0]?.qty || 0;
      }
      let price = detailsData?.price;
      if (detailsData?.specialPrice && detailsData?.specialPrice > 0 && detailsData?.price) {
        price = detailsData?.specialPrice;
      }

      const asterBadge = productDetails?.badgeDetails?.asterBadge;
      const lowestPriceLabel = productDetails?.lowestPriceLabel;

      let badgeContents = [];

      if (Array.isArray(asterBadge)) {
        badgeContents = asterBadge?.map((badge) => badge.content);
      } else if (asterBadge) {
        badgeContents = [asterBadge.content];
      }

      const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
      if (formattedLowestPriceLabel) {
        badgeContents.push(formattedLowestPriceLabel);
      }     
      localStorage.setItem('is_view_item_called', true);
    }
    return () => {
      localStorage.removeItem('is_view_item_called');
    };
  }, [getGuestLoginMemo]);

  useEffect(() => {
    let sphErrors = null;
    if(errors?.sph?.leftOrDefaultInvalid && errors?.sph?.rightInvalid) {
      sphErrors = "double sph";
    } else if(errors?.sph?.leftOrDefaultInvalid && !errors?.sph?.rightInvalid) {
      sphErrors = "single sph";
    };
    if(errors?.sph && Object.keys(errors?.sph).length) {
      const errorParams = {
        screen_name: productDetails?.name,
        page_type: 'product details page',
        product_name: productDetails?.name,
        product_sku: productDetails?.sku,
        error: errors?.sph?.msg,
        type: sphErrors,
        myaster_category: ONE_ASTER_CATEGORY.PHARMACY
      };
      dataLayerSendEvent('eye_power_error', errorParams);
    }
  }, [errors]);

  const removeQueryParam = (deleteParams) => {
    const query = router?.query;
    delete query[`${deleteParams}`];
    router.push(
      {
        query,
      },
      undefined,
      {
        shallow: true,
      },
    );
  };
  React.useEffect(() => {
    if (urlKey?.length > 0 && userLocation?.location !== null) {
      let params = { sku: urlKey[urlKey.length - 1] };

      if (categoryId) {
        params = {
          ...params,
          ...{ categoryId },
          ...(isFromRecentSearch && { isFromRecentSearch }),
        };
      }
      if (zoneData) {
        params.zoneIdList = zoneData?.join(',');
      }
      setIsFirstCalled(false);
      if (!isFirstCalled) {
        if (guestLogin || userLogin) {
          dispatch(
            getProductDetails({
              params,
              onSuccess: (response) => {
                const asterBadge = detailsData?.badgeDetails?.asterBadge;
                const lowestPriceLabel = detailsData?.lowestPriceLabel;

                let badgeContents = [];

                if (Array.isArray(asterBadge)) {
                  badgeContents = asterBadge?.map((badge) => badge.content);
                } else if (asterBadge) {
                  badgeContents = [asterBadge.content];
                }

                const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
                if (formattedLowestPriceLabel) {
                  badgeContents.push(formattedLowestPriceLabel);
                }

                let variantProductResponse = isOpticalProduct ? getOpticsData(response?.body) : {};
                variantProductResponse = { ...response?.body, ...variantProductResponse };
                setDetailsData(variantProductResponse);
                let qty = 0;
                const currentCartItem = getCartV2Data?.itemsToCart?.filter(
                  (cartItem) => cartItem?.sku === response?.data?.sku,
                );
                if (currentCartItem?.length > 0) {
                  qty = currentCartItem?.[0]?.qty || 0;
                }
                let price = response?.data?.price;
                if (response?.data?.specialPrice && response?.data?.specialPrice > 0 && response?.data?.price) {
                  price = response?.data?.specialPrice;
                } 
                localStorage.setItem('is_view_item_called', true);
                if (params.isFromRecentSearch) {
                  removeQueryParam('isFromRecentSearch');
                }
              },
              onFailure: (err) => {
                errorHandlingEpharmacy(err, true, commonAnalyticsProps?.current?.screenName, commonAnalyticsProps?.current?.pageType);
              },
            }),
          );
        }
      }
    }
  }, [categoryId, id, urlKey, userLocation?.zone, getGuestLoginMemo]);

  React.useEffect(() => {
    if (router?.asPath?.includes('sku-')) {
      setSkuForAddToCart(id);
    }
    setSkuForAddToCart(detailsData?.sku);
  }, [detailsData?.sku, id, router?.asPath]);

  let title = detailsData?.name;
  if (homePageSeoData?.staticPageSeo?.productPage?.title) {
    title = String(homePageSeoData.staticPageSeo.productPage.title).replace(/{productTitle}/g, `${detailsData?.name}`);
  }

  let description = `${detailsData?.name}`;
  if (homePageSeoData?.staticPageSeo?.productPage?.description) {
    description = String(homePageSeoData.staticPageSeo.productPage.description).replace(
      /{productTitle}/g,
      `${detailsData?.name}`,
    );
  }
  const metaData = {
    title,
    description,
    meta: [
      {
        name: 'title',
        value: title,
      },
      {
        name: 'description',
        value: description,
      },
      {
        name: 'keywords',
        value: detailsData?.metaDetails?.metaKeywords,
      },
      {
        name: 'image',
        value: customAttribute?.image,
      },
      {
        name: 'og:locale',
        value: 'en_US',
      },
      {
        name: 'og:type',
        value: 'article',
      },
      {
        name: 'og:title',
        value: detailsData?.metaDetails?.metaTitle,
      },
      {
        name: 'og:description',
        value: detailsData?.metaDetails?.metaDescription,
      },
      {
        name: 'og:url',
        value: detailsData?.metaDetails?.canonicalTag,
      },
      {
        name: 'og:site_name',
        value: '@myaster',
      },
      {
        name: 'og:image',
        value: customAttribute?.image,
      },
      {
        name: 'og:image:secure_url',
        value: customAttribute?.image,
      },
      {
        name: 'twitter:card',
        value: 'Products',
      },
      {
        name: 'twitter:title',
        value: detailsData?.name,
      },
      {
        name: 'twitter:description',
        value: customAttribute?.description,
      },
      {
        name: 'twitter:site',
        value: '@myaster',
      },
      {
        name: 'twitter:image',
        value: customAttribute?.image,
      },
    ],
  };

  const removeDecimalPoints = (x) => {
    if (typeof x === 'number') {
        x = x.toString();
    }
    if (x.split('.').length > 1 && parseInt(x.split('.')[1]) === 0) {
        return parseInt(x);
    }
    if (x.includes('.')) {
        return Number.parseFloat(x).toFixed(2);
    }
    return x;
};

  useEffect(() => {
    if (router?.query?.selectedSPHSku && detailsData) {
      const productVariants = Object.entries(detailsData.extensionAttributes.variantData[0]?.variants);
      if (productVariants) {
        const selectedSPH = productVariants.find(([, variant]) => variant.sku === router?.query?.selectedSPHSku );
        if (selectedSPH) {
          setSelectedSPHSkus({
            isDifferentSPH: false,
            leftOrDefault: {
              id: selectedSPH?.[0],
              displayText: selectedSPH?.[1]?.productData.customAttribute.find((x) => x.attributeCode === 'power')?.value,
              sku: selectedSPH?.[1]?.sku,
            },
          });
        }
      }
    }
    EventEmitter.dispatch('fetchWishList', {zone: userZoneData, userLogin});
  }, []);

  useEffect(() => {
    pageViewEventFired.current = false;
  }, [pageId]);

  const sendViewItemEvent = () => {
    const asterBadge = detailsData?.badgeDetails?.asterBadge;
    let badgeContents = [];

    if (Array.isArray(asterBadge)) {
      badgeContents = asterBadge?.map((badge) => badge.content);
    } else if (asterBadge) {
      badgeContents = [asterBadge.content];
    }

    dataLayerSendEvent('view_item', {
      currency: getCurrencyFromRegion(),
      ecommerce: {
        items: [
          {
            ...getProductItemObjectEventFillersSelect(detailsData),
          },
        ],
      },
      availability: detailsData?.outOfStock
        ? ASTER_PRODUCT_AVAILABILITY.OUT_OF_STOCK
        : ASTER_PRODUCT_AVAILABILITY.IN_STOCK,
      product_type: productDetails?.productType === 'Optics' ? 'Optics' : ASTER_PRODUCT_TYPES.PHARMACY,
      product_sku: detailsData?.sku,
      delivery_promise: detailsData?.deliverByV2 || detailsData?.deliverBy || null,
      express_availability: detailsData?.express ? 'true' : 'false',
      referrer_page: referrerPage,
      product_name: detailsData?.name,
      screen_name: commonAnalyticsProps?.current?.screenName,
      page_type: commonAnalyticsProps?.current?.pageType,
      page_id: router?.query?.product[1]?.split('?')?.[0],
      bundle_deal_availability: detailsData?.isBundled ? 'true' : 'false',
      promotion_name: badgeContents?.length > 0 ? badgeContents : null,
      promotion_value_tag: productDetails?.badgeDetails?.offerBadge
        ? `${productDetails?.badgeDetails?.offerBadge}% Off!`
        : null,
      initiation_source: router?.query?.notify_src,
      last_visited_product_name: detailsData?.name,
      last_visited_product_url: `${location?.origin}${getProductPath(detailsData)}`,
    });
  };

  const sendPageViewEvent = () => {
    if (pageViewEventFired.current) return;

    pageViewEventFired.current = true;
    const params = {
      screenName: detailsData?.name || router?.asPath,
      pageType: 'product details page',
      referrerPage,
      pageId: detailsData?.sku,
    };

    commonAnalyticsProps.current = params;
    dataLayerSendEpharmacyPageViewEvent(params);
    sendViewItemEvent();
  };

  React.useEffect(() => {
    if (detailsData) {
      sendAdjustViewContentPharmacyEvent(ADJUST_EVENT_TOKENS.VIEWED_CONTENT_PHARMACY, detailsData.sku);
      sendPageViewEvent();
    }
  }, [detailsData]);

  const productSchemaData = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: detailsData?.name,
    image: customAttribute?.smallImage ?? PRODUCT_CARD_DEFAULT?.src,
    description: customAttribute?.description,
    brand: {
      '@type': 'Brand',
      name: detailsData?.brandDetails?.brandName,
    },
    sku: detailsData?.sku,
    offers: {
      '@type': 'Offer',
      url: router.asPath,
      priceCurrency: 'AED',
      price: detailsData?.price,
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
    },
  };

  const brandData = detailsData?.extensionAttributes?.specifications?.find(
    (attItem) => attItem?.attributeCode === 'brand',
  );
  const categoryLinks = detailsData?.extensionAttributes?.categoryLinks;
  const catLinksLength = categoryLinks?.length;
  const catID = categoryLinks?.[catLinksLength - 1]?.categoryId || '';

  const categoryPathDetail= detailsData?.categoryPathDetail;
  const categoryPathLength = categoryPathDetail?.length;
  const catLID = categoryPathDetail?.[categoryPathLength - 1]?.id || '';
  const catLID_name = categoryPathDetail?.[categoryPathLength - 1]?.name || '';

  const scrollToReviewBottom = () => {
    ratingsBottomRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };

  React.useEffect(() => {
    if (detailsData?.sku) {
      const fbtSkuIDs = [];
      detailsData?.productLink?.forEach((item) => {
        fbtSkuIDs.push(item.linkedProductSku);
      });
      fbtSkuIDs.unshift(detailsData?.sku);
      setFBTSkuId(fbtSkuIDs);
      if (zoneData?.length > 0) {
        dispatch(
          getFBTProductsBySearch({
            params: { skuIds: fbtSkuIDs, zone: zoneData.join(',') },
            onSuccess: (res) => {
              setFbtProducts(res);
            },
            onFailure: (err) => {
              errorHandlingEpharmacy(err, true, commonAnalyticsProps?.current?.screenName, commonAnalyticsProps?.current?.pageType);
            },
          }),
        );
      }
    }
  }, [zoneData, detailsData?.sku]);

  React.useEffect(() => {
    if(!getCartV2Data){
      EventEmitter.dispatch('fetchCartDetails', { cartIdParam: cartDataInitial?.body?.cart_id });
    }
    let counter = 0;
    const fbtArray = fbtProducts?.filter((item) => item.sku !== detailsData?.sku);
    const reqLength = fbtArray?.length;
    const fbtinstock = fbtProducts?.filter((item) => item?.inStock === false);
    const fbtshow3 = fbtProducts?.filter((item) => item?.inStock === true);
    setFbt_isStock(fbtinstock);
    setFbtshow3(fbtshow3);
    fbtArray?.map((item) => {
      if (!item.inStock) {
        counter++;
      }
    });
    if (reqLength === counter) {
      setIsFBTEnabled('false');
    }
  }, []);

  useEffect(() => {
    const product_sku = reducerItems?.map((item) => item?.item_id);
    const qty = reducerItems?.map((item) => item?.qty);
    const price = reducerItems?.map((item) => parseFloat(item?.price));
    setCartProperties((prevState) => ({
      ...prevState,
      cartItem_sku: product_sku,
      cartItem_qty: qty,
      cartItem_Price: price,
    }));
  }, [cartDataInitial?.body, reducerItems]);

  useEffect(() => {
    if (cartProperties.itemFiller_sku?.length > 0 || cartProperties.cartItem_sku?.length > 0) {
      const cartItemQtyPriceMap = cartProperties?.cartItem_sku?.reduce((map, sku, index) => {
        map[sku] = {
          qty: cartProperties?.cartItem_qty?.[index] ?? 0,
          price: cartProperties?.cartItem_Price?.[index] ?? 0,
        };
        return map;
      }, {});
       const totalQty =
        cartProperties?.cartItem_sku?.reduce((acc, sku) => {
          const qtyInCart = cartItemQtyPriceMap ? cartItemQtyPriceMap?.[sku]?.qty ?? 0 : 0;
          return acc + qtyInCart;
        }, 0);

       const totalPrice =
        cartProperties?.cartItem_sku?.reduce((acc, sku) => {
          const qtyInCart = cartItemQtyPriceMap?.[sku]?.qty ?? 0;
          const price = cartItemQtyPriceMap?.[sku]?.price ?? 0;
          return acc + (qtyInCart * price);
        }, 0);

      setUpsellingqty(totalQty);
      setUpsellingprice(parseFloat(Number(totalPrice?.toFixed(2))));
    }
  }, [
    cartProperties.itemFiller_sku,
    cartProperties.cartItem_sku,
    cartProperties.cartItem_qty,
    cartProperties.cartItem_Price,
    selectedCartItem,
    detailsData,
  ]);

  const hasRenderedOnce = useRef(false);

  React.useEffect(() => {
    if (showUpselling && !hasRenderedOnce.current) {
      dataLayerSendEvent('upselling_popup_viewed', {
        type:
          (fbtSkuId?.length > 1 && !fbt_isStock?.length > 0 && !fbt_disabled) || fbtshow3?.length === 2
            ? 'fbt upselling'
            : 'pdp upselling',
        screen_name: router?.query?.product[0]?.replace(/-/g, ' '),
        page_type: 'product details page',
        page_id: router?.query?.product[1]?.split('?')?.[0],
        myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
        product_sku: detailsData?.sku,
        product_name: detailsData?.name,
      });
      sendEventToSmartLook('upselling_popup_viewed');

    if ((fbtSkuId?.length > 1 && !(fbt_isStock?.length > 0) && !fbt_disabled) || fbtshow3?.length === 2) {
      dataLayerSendEvent('view_item_list', {
        ecommerce: {
          items: fbtProducts?.map((element, index) => ({ ...getProductItemObject(element), index })),
        },
        section_name:
          (fbtSkuId?.length > 1 && !fbt_isStock?.length > 0 && !fbt_disabled) || fbtshow3?.length === 2
            ? 'fbt upselling'
            : 'pdp upselling',
        screen_name: router?.query?.product[0]?.replace(/-/g, ' '),
        page_type: 'product details page',
        page_id: router?.query?.product[1]?.split('?')?.[0],
        referrer_page: referrerPage,
        myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
      });
      sendEventToSmartLook('view_item_list');
    }

      hasRenderedOnce.current = true;
    }
  }, [showUpselling]);

  const hasRendered = useRef(false);

  React.useEffect(() => {
    if (showUpselling && !hasRendered.current && fbtSkuId?.length === 1) {
      dataLayerSendEvent('view_item_list', {
        ecommerce: {
          items: cartFillers?.map((element, index) => ({ ...getProductItemObject(element), index })),
        },
        section_name:
        (fbtSkuId?.length > 1 && !fbt_isStock?.length > 0 && !fbt_disabled) || fbtshow3?.length === 2
          ? 'fbt upselling'
          : 'pdp upselling',
        screen_name: router?.query?.product[0]?.replace(/-/g, ' '),
        page_type: 'product details page',
        page_id: router?.query?.product[1]?.split('?')?.[0],
        referrer_page: referrerPage,
        myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
      });
    }
  }, [showUpselling]);

  React.useEffect(() => {
    if (appConfig && appConfig.length > 0) {
      setIsReviewsEnable(getConfigurationActiveValueByName(appConfig, PRODUCT_REVIEW_FLAG));
      setIsRatingsEnable(getConfigurationActiveValueByName(appConfig, PRODUCT_RATINGS_FLAG));
      setIsFBTEnabled(getConfigurationActiveValueByName(appConfig, FBT_SECTION_FLAG));
      setPdpUpSellingFlag(getConfigurationActiveValueByName(appConfig, PDP_UPSELLING_FLAG));
    }
  }, [appConfig?.length]);

  const scrollToViewFBT = () => {
    setTimeout(() => {
      scrollRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, 2000);
  };

  const checkIfInCart = (productId, deleteId) => {
    setFbtProductId(productId);
    setDeleteProductID(deleteId);
  };

  const emptyProductId = () => {
    setFbtProductId('');
    setDeleteProductID([]);
  };

  const renderVariant = () => {
    if (isOpticalProduct) {
      const sphOptions =
        detailsData?.extensionAttributes?.groups?.filter((item) => item?.code === 'power')?.[0]?.options ?? [];
      return (
        <OpticalVariant
          sphOptions={sphOptions}
          setSelectedSPHSkus={setSelectedSPHSkus}
          selectedSPHSkus={selectedSPHSkus}
          variants={detailsData?.extensionAttributes?.variantData?.[0]?.variants}
          errors={errors}
          productDetails={detailsData}
        />
      );
    }

    return null;
  };

  const emptySphValues = () => {
    setSelectedSPHSkus(null);
  }

  const fbtCondition =
    isFBTEnabled === 'true' && detailsData?.outOfStock === false && detailsData?.productLink?.length > 0;

  const fbtSectionRef = useRef();
  const fbtSectionViewFired = useRef();
  const handleFBTSectionView = () => {
    if (!fbtSectionViewFired.current && fbtProducts?.length > 1) {
      fbtSectionViewFired.current = true;
      dataLayerSendEvent('view_item_list', {
        ecommerce: {
          items: fbtProducts?.map((element, index) => ({ ...getProductItemObject(element), index })),
        },
        section_name: 'pdp - fbt',
        screen_name: router?.query?.product[0]?.replace(/-/g, ' '),
        page_type: 'product details page',
        page_id: router?.query?.product[1]?.split('?')?.[0],
        referrer_page: referrerPage,
        myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
      });
      sendEventToSmartLook('view_item_list');
    }
  };
  const qtyLength =
    Number(detailsData?.availableStock) > MAX_QTY_ADD_TO_CART_PER_ORDER
      ? MAX_QTY_ADD_TO_CART_PER_ORDER
      : Number(detailsData?.availableStock);

  const FBTSectionWithAnalytics = withAnalytics(
    () => (
      <div ref={fbtSectionRef}>
        <FBTSection
          fbtSkuId={fbtSkuId}
          productInCart={fbtProductId}
          notInCart={deleteProductID}
          emptyProductId={emptyProductId}
          screenName={router?.query?.product[0]?.replace(/-/g, ' ')}
          page_id={router?.query?.product[1]?.split('?')?.[0]}
          referrer_page={referrerPage}
          fbtProducts={fbtProducts}
          screenType={detailsData?.categoryPath?.[0]?.label ? detailsData?.categoryPath?.[0]?.label : 'Product Details'}
          pageType="PDP"
          disable={selectedCartItem?.qty >= qtyLength ? true : false}
        />
      </div>
    ),
    handleFBTSectionView,
    fbtSectionRef,
  );
  
  const isPOMEnabled = pomFlag?.enabled && detailsData?.itemLabels?.includes(AE_GLOBAL?.RX);

  const breadcrumbChilds = web_feature_flaging?.isBreadcrumbAEDisabled
  ? [
    { text: t('Breadcrumb.home'), link: generateURL(ONLINE_PHARMACY_ROUTE) }, 
    ...[
      detailsData?.categoryPathDetail?.[0]
        ? {
            text: detailsData?.categoryPathDetail[0]?.name,
            link: generateURL(`${ONLINE_PHARMACY_ROUTE}${detailsData?.categoryPathDetail[0]?.url}`),
          }
        : null,
      detailsData?.categoryPathDetail?.[1]
        ? {
            text: detailsData?.categoryPathDetail[1]?.name,
            link: generateURL(`${ONLINE_PHARMACY_ROUTE}${detailsData?.categoryPathDetail[1]?.url}`),
          }
        : null,
      detailsData?.categoryPathDetail?.[2]
        ? {
            text: detailsData?.categoryPathDetail[2]?.name,
            link: generateURL(`${ONLINE_PHARMACY_ROUTE}${detailsData?.categoryPathDetail[2]?.url}`),
          }
        : null,
    ].filter(Boolean)
  ]
  : [
    { text: t('Breadcrumb.home'), link: generateURL(HOME) }, 
    { text: t('Home.onlinePharmacy'), link: generateURL(ONLINE_PHARMACY_ROUTE) }, 
    ...[
      detailsData?.categoryPathDetail?.[0]
        ? {
            text: detailsData?.categoryPathDetail[0]?.name,
            link: generateURL(`${ONLINE_PHARMACY_ROUTE}${detailsData?.categoryPathDetail[0]?.url}`),
          }
        : null,
      detailsData?.categoryPathDetail?.[1]
        ? {
            text: detailsData?.categoryPathDetail[1]?.name,
            link: generateURL(`${ONLINE_PHARMACY_ROUTE}${detailsData?.categoryPathDetail[1]?.url}`),
          }
        : null,
      detailsData?.categoryPathDetail?.[2]
        ? {
            text: detailsData?.categoryPathDetail[2]?.name,
            link: generateURL(`${ONLINE_PHARMACY_ROUTE}${detailsData?.categoryPathDetail[2]?.url}`),
          }
        : null,
    ].filter(Boolean)
  ]

  return (
    <ProductDetailsStyled className={currentLang && isRTL(currentLang) ? 'rtl' : ''} isScheduled={detailsData?.isScheduled && isSheduledExpress} scheduledDeliveryMessage={detailsData?.scheduledDeliveryMessage && showSheduledDeliveryMessage} >
      <Loader
        isLoading={
          loadingProductDetailsWeb || loadingProductDetails || detailLoading || userLocationLoading || deleteLoader
        }
      />
      <CommonMeta metaData={metaData} />
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchemaData) }} />
      </Head>
      <div className="pageContent pb-0">
        <HeaderBelow screenName={detailsData?.name} pageType={PAGE_NAME?.PDP_AE} hidePointsBox />
        {detailsData?.sku !== undefined && (
          <Container>
            <Row className="py-3">
              {categoryId ? (
                <BreadcrumbControl appVariant="epharmacy" main={detailsData?.name} childs={BreadcrumsData} />
              ) : (
                <BreadcrumbControl
                  appVariant="epharmacy"
                  pageType = {PRODUCTS_DETAILS_PAGE}
                  main={detailsData?.name}
                  childs={breadcrumbChilds}
                />
              )}
            </Row>

            <div className="productDetailWrapper">
              <ProductShowCase
                detailsData={detailsData}
                customAttribute={customAttribute}
                setShowVideo={setShowVideo}
                showVideo={showVideo}
                setSelectedMediaId={setSelectedMediaId}
                selectedMediaID={selectedMediaID}
                isPOMEnabled={isPOMEnabled}
              />
              <div className="productInfoWrapper">
                <div className="productDetailInfo">
                  <div className="brandNameProductNameOuter">
                    <div className="brandNameProductNameInner">
                    {brandData?.label && (
                        <div data-test="brandNameClick" className="brandName">
                          <Link
                            href={generateURL(`${
                              navigationUrl
                                ? `${ONLINE_PHARMACY_ROUTE}/${navigationUrl}`
                                : `${ONLINE_PHARMACY_ROUTE}/brand/${detailsData?.brandDetails?.brandName
                                    ?.toLowerCase()
                                    ?.replace(/ /g, '-')
                                    ?.replace(/[^a-zA-Z0-9-]/g, '-')
                                    ?.replace(/-{2,}/g, '-')}/${brandData?.value}`
                            }`)}
                          >
                            {brandData?.label}
                          </Link>
                        </div>
                      )}
                      <div className="productName">{detailsData?.name}</div>
                    </div>
                  </div>
                  <div className="Bundle_deal_pdp">
                    {detailsData?.tierPrices?.bundles?.length > 0 && !isPOMEnabled && (
                      <Image src={BUNDLE_DEAL_PDP_UPDATED} alt="Bundle_deal_pdp" className="Bundle_deal_pdp" />
                    )}
                    {!isPOMEnabled && !detailsData?.outOfStock &&
                    detailsData?.badgeDetails?.offerBadge > 0 &&
                    customAttribute?.special_to_date && (
                      <OfferTimeCounter pageType={PAGE?.PDP} time={new Date(customAttribute?.special_to_date)} />
                    )}
                    {isRatingsEnable === 'true' && detailsData?.avgRating && Number(detailsData?.avgRating) > 0 && web_feature_flaging?.isRatingsReviewEnabled && (
                      <div
                      onClick={scrollToReviewBottom}
                      className="starRating"
                    >
                      <StarRatingNumberOnly className="onPDP" ratings={detailsData?.avgRating} />
                    </div>)}
                  </div>
                  <div className="priceContainer">
                    <div className="priceWrapper">
                      {isPOMEnabled && detailsData?.itemLabels?.includes(AE_GLOBAL?.RX) ? (
                        <div className="price">
                          <div>{detailsData?.currency}</div> <div>{removeDecimalPoints(detailsData?.price)}</div>
                        </div>
                      ) :(Number(detailsData?.specialPrice) > 0 && (Number(detailsData?.specialPrice) !== Number(detailsData?.price))) ? (
                        <div className="price">
                          <div>{detailsData?.currency}</div> <div>{removeDecimalPoints(detailsData?.specialPrice)}</div>
                          <span>
                            <div>{detailsData?.currency}</div>&nbsp;<div>{removeDecimalPoints(detailsData?.price)}</div>
                          </span>
                        </div>
                      ) : (
                        <div className="price">
                          <div>{detailsData?.currency}</div> <div>{removeDecimalPoints(detailsData?.price)}</div>
                        </div>
                      )}
                      <div className="tax">({t('ProductDetail.priceSubTxt')})</div>
                    </div>
                    {web_feature_flaging?.isSecurePointsEnabledKsaUser &&
                      <div className="points-wrapper">
                        <div className="ic-point-heart">
                          <Image src={IC_HEART.src} width="50px" height="50px" alt={detailsData?.name} />
                        </div>
                        <div className="ms-2 ">
                          {detailsData?.loyaltyPoints}
                          <span className="ms-1 "> {t('ProductDetail.Pts')}</span>
                        </div>
                      </div>
                    }
                  </div>
                  <div className='lowest-price-and-stock'>
                    {productDetails?.lowestPriceLabel && <div className='lowest-price'>{productDetails?.lowestPriceLabel}</div>}
                    {!detailsData?.outOfStock && detailsData?.lowStock && (
                      <div className="stock">{t('ProductDetail.stockLeft', {stock: detailsData?.availableStock})}</div>
                    )}
                  </div>
                  
                  {!loadingProductDetailsWeb &&
                    !loadingProductDetails &&
                    !detailLoading &&
                    !userLocationLoading &&
                    detailsData?.outOfStock === false && (
                      <DeliveryDetails
                        detailsData={detailsData}
                        productDetails={productDetails}
                        isSheduledExpress={isSheduledExpress}
                        showSheduledDeliveryMessage={showSheduledDeliveryMessage}
                        isPOMEnabled={isPOMEnabled}
                        pdpPomText={pdpPomText}
                      />
                    )}
                  {web_feature_flaging?.isCartEnable && 
                    !loadingProductDetailsWeb &&
                    !loadingProductDetails &&
                    !detailLoading &&
                    !userLocationLoading &&
                    detailsData?.outOfStock === true && (
                      <Col lg={12}>
                        <div data-test="temporary_out_of_stock" className="tempOOS">
                          <strong>{t('ProductDetail.tempOutOfStock')}</strong>
                        </div>
                      </Col>
                    )}
                  {productHasVariants && renderVariant()}
                  {detailsData?.tierPrices?.bundles?.length > 0 && !isPOMEnabled && (
                    <div className="bundle-offer">
                      <BundleOffer
                        bundledata={detailsData?.tierPrices}
                        pageId={router?.query?.product[1]?.split('?')?.[0]}
                        pageType={'product details page'}
                        screenName={router?.query?.product[0]?.replace(/-/g, ' ')}
                        productName={detailsData?.name}
                        sku={isOpticalProduct ? selectedSPHSkus : skuForAddToCart || detailsData?.sku}
                      />
                    </div>
                  )}
                  <div className={`order-wrapper${web_feature_flaging?.isCartEnable ? " order-wrapper-fixed" : ""}`}>
                    {web_feature_flaging?.isCartEnable && windowWidth >= MIN_MOBILE_WIDTH  && (
                    <div className="noDesktop">
                      <div className="priceWrapper">
                        {detailsData?.specialPrice ? (
                          <div className="price">
                            {detailsData?.currency} {removeDecimalPoints(detailsData?.specialPrice)}
                            &nbsp;
                            <span>
                              {detailsData?.currency} {removeDecimalPoints(detailsData?.price)}
                            </span>
                          </div>
                        ) : (
                          <div className="price">
                            {detailsData?.currency} {removeDecimalPoints(detailsData?.price)}
                          </div>
                        )}
                      </div>
                    </div>)}
                    {web_feature_flaging?.isCartEnable ?
                      <AddToCart
                        size="md"
                        minWidth="140px"
                        isFloat
                        isProductDetails
                        availableStock={detailsData?.availableStock}
                        sku={isOpticalProduct ? selectedSPHSkus : skuForAddToCart || detailsData?.sku}
                        outOfStock={detailsData?.outOfStock}
                        productName={detailsData?.name}
                        productType=""
                        productCategory={
                          detailsData?.categoryPath ? detailsData?.categoryPath : customAttribute?.categoryIds
                        }
                        price={detailsData?.specialPrice ? detailsData?.specialPrice : detailsData?.price}
                        offer={detailsData?.badgeDetails?.offerBadge ? 'yes' : 'no'}
                        product={detailsData}
                        deliveryPromise={detailsData?.express === true ? 'Express' : 'Standard'}
                        brand={detailsData?.brandDetails?.brandName}
                        screenType={
                          detailsData?.categoryPath?.[0]?.label
                            ? detailsData?.categoryPath?.[0]?.label
                            : 'Product Details'
                        }
                        sectionName={isFBTEnabled ? 'Product Details Page - FBT' : 'Product Details Page'}
                        categories={detailsData?.categoryPath}
                        deliverBy={detailsData?.deliverBy}
                        scrollRef={scrollRef}
                        fbtCondition={fbtCondition}
                        checkIfInCart={checkIfInCart}
                        scrollToViewFBT={scrollToViewFBT}
                        pdpUpSellingFlag={pdpUpSellingFlag}
                        isFBTEnabled={isFBTEnabled}
                        setShowUpselling={setShowUpselling}
                        isBundle={isPOMEnabled ? false : detailsData?.isBundled}
                        bundleflag={detailsData?.tierPrices?.bundles?.length > 0}
                        BundleDetails={isPOMEnabled ? null : detailsData?.tierPrices}
                        BundleImage={customAttribute?.small_image}
                        productDetails={detailsData}
                        setErrors={setErrors}
                        errors={errors}
                        screenName={detailsData?.name}
                        pageId={detailsData?.sku}
                        pageType={'product details page'}
                        referrerpage={referrerPage}
                      />
                    :
                      <DownloadAppSection
                        screenName={detailsData?.name}
                        pageId={detailsData?.sku}
                        pageType={'product details page'}
                        id={isOpticalProduct ? selectedSPHSkus : skuForAddToCart || detailsData?.sku}
                        itemName={detailsData?.name}
                        deliveryPromise={detailsData?.deliverByV2 || detailsData?.deliverBy || null}
                        expressAvailability={!!detailsData?.express}
                        itemCategory={catLID_name || ''}
                      />
                    }
                    {selectedCartItem > 0 && (
                      <ButtonBase
                        onClick={() => {
                          router.push({
                            pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/mycart`),
                          });
                        }}
                        customClass="noDesktop btnGoToCart"
                        variant="success"
                        text={t('ProductDetail.goToCart')}
                      />
                    )}
                  </div>
                </div>

                <div className="uspBox">
                  <div className="usp">
                    <div className="ic">
                      <Image src={IC_TRUSTED_SHIPPING.src} width="50px" height="50px" alt="" />
                    </div>
                    <div className="name">{t('ProductDetail.trusterShipping')}</div>
                  </div>
                  <div className="usp">
                    <div className="ic">
                      <Image src={IC_SECURE_PAYMENT.src} width="50px" height="50px" alt="" />
                    </div>
                    <div className="name">{t('ProductDetail.securePayment')}</div>
                  </div>
                  <div className="usp">
                    <div className="ic">
                      <Image src={IC_ORIGINAL.src} width="50px" height="50px" alt="" />
                    </div>
                    <div className="name">{t('ProductDetail.genuineBrands')}</div>
                  </div>
                </div>

                <ProductHighLights
                  overview={detailsData?.extensionAttributes?.overview}
                  highlights={detailsData?.extensionAttributes?.highlights}
                />

                {fbtCondition && !isPOMEnabled && (
                 <FBTSectionWithAnalytics/>
                )}
                {showUpselling && !isPOMEnabled && (
                  <RightSideBar
                    modalTitle={
                      (fbtSkuId?.length > 1 && !fbt_isStock?.length > 0 && !fbt_disabled) || fbtshow3?.length === 2
                        ? 'Frequently Bought Together'
                        : 'You may also like'
                    }
                    size="md"
                    noFooter
                    closeButton
                    customClass="upsellingModal"
                    footerEnable
                    isPrimaryButtonDisabled={false}
                    isProductDetails={true}
                    primaryButtonText="Go To Cart"
                    isPromotionCart={
                      fbtSkuId?.length > 1 && fbtshow3?.length === 3 && fbtshow3?.length === 2 ? false : true
                    }
                    isshowUpselling={showUpselling}
                    detailsData={detailsData}
                    upsellingprice={upsellingprice}
                    upsellingqty={upsellingqty}
                    pdp_price={pdp_price}
                    pdp_qty={pdp_qty}
                    footerBtnFullWidth
                    fbt_isStock={fbt_isStock}
                    fbtshow3={fbtshow3}
                    fbt_disabled={fbt_disabled}
                    cartFillers={cartFillers}
                    cartFillerLen={cartFillerLen}
                    showUpselling={showUpselling}
                    fbtSkuId={fbtSkuId}
                    primaryButtonClicked={() => {
                      router.push({ pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/mycart`) });
                    }}
                    secondaryButtonClicked={() => {}}
                    handleClose={() => {
                      setShowUpselling(false);
                      hasRenderedOnce.current = false;
                      dataLayerSendEvent('upselling_popup_dismissed', {
                        type:
                          (fbtSkuId?.length > 1 && !fbt_isStock?.length > 0 && !fbt_disabled) || fbtshow3?.length === 2
                            ? 'fbt upselling'
                            : 'pdp upselling',
                        screen_name: router?.query?.product[0]?.replace(/-/g, ' '),
                        page_type: 'product details page',
                        page_id: router?.query?.product[1]?.split('?')?.[0],
                        referrer_page: referrerPage,
                        myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
                      });
                      sendEventToSmartLook('upselling_popup_dismissed');
                    }}
                  >
                    <div className="section_box_body">
                      <FBTStyled>
                        <div className="main-product-wrapper">
                          <div className="main-product-img">
                            {customAttribute?.small_image ? (
                              <img src={customAttribute.small_image} alt={customAttribute.name} />
                            ) : (
                              <Image src={PRODUCT_CARD_DEFAULT} alt="PLUS_ICON" className="main-product-img" />
                            )}
                          </div>
                          <div className="main-product-name">
                            {customAttribute?.item_name}
                            <div className="union-logo">
                              <Image src={IC_GREEN_TICK} alt="UNION_LOGO" />
                              <div className="tick_added">Added To Cart</div>
                            </div>
                          </div>
                        </div>
                        <div className="divider" />
                      </FBTStyled>
                      {((fbtSkuId?.length > 1 && !fbt_isStock?.length > 0 && !fbt_disabled) ||
                        (fbtshow3?.length === 2 && fbtSkuId?.length === 3)) && (
                        <FBTUpsellingSection
                          fbtSkuId={fbtSkuId}
                          setFbt_disabled={setFbt_disabled}
                          productInCart={fbtProductId}
                          customAttribute={customAttribute}
                          notInCart={deleteProductID}
                          fbtProductsDatas={fbtProducts}
                          setShowUpselling={setShowUpselling}
                          emptyProductId={emptyProductId}
                          isshowUpselling={showUpselling}
                          screenName={detailsData?.name}
                          sectionName='fbt upselling'
                          pageId={detailsData?.sku}
                          fbtProducts={fbtProducts}
                          referrerpage={referrerPage}
                          screenType={
                            detailsData?.categoryPath?.[0]?.label
                              ? detailsData?.categoryPath?.[0]?.label
                              : 'Product Details'
                          }
                          pageType='product details page'
                        />
                      )}
                    </div>
                    {((cartFillers?.length > 0 && fbtSkuId?.length === 1) ||
                      (cartFillers?.length > 0 && fbtSkuId?.length === 3 && fbt_isStock?.length === 2) ||
                      (cartFillers?.length > 0 && fbtSkuId?.length === 2 && fbt_isStock?.length === 1) ||
                      (cartFillers?.length > 0 && fbt_disabled)) && (
                      <>
                        {cartFillers?.map((cartItem) => (
                          <CartFillerMiniCart
                            key={cartItem.id}
                            item={cartItem}
                            isPromotionCart
                            setShowUpselling={setShowUpselling}
                            showUpselling={showUpselling}
                            referrerpage={referrerPage}
                            showevent={showUpselling}
                            isSheduledExpress={isSheduledExpress}
                            cartFillers={cartFillers}
                            screenName={detailsData?.name}
                            pageId={detailsData?.sku}
                            pageType="product details page"
                            sectionName="pdp upselling"
                            isInRightSideBar
                          />
                        ))}
                      </>
                    )}
                  </RightSideBar>
                )}
                <ProductOffers sku={detailsData?.sku} isPOMEnabled={isPOMEnabled} detailsData={detailsData} customAttribute={customAttribute}/>
              </div>
              <ScrolledCartDetails
                skuForAddToCart={isOpticalProduct ? selectedSPHSkus : skuForAddToCart || detailsData?.sku}
                brandData={brandData}
                detailsData={detailsData}
                removeDecimalPoints={removeDecimalPoints}
                scrollToView={scrollToViewFBT}
                checkIfInCart={checkIfInCart}
                pdpUpSellingFlag={pdpUpSellingFlag}
                isFBTEnabled={isFBTEnabled}
                setErrors={setErrors}
                screenName={detailsData?.name}
                pageId={detailsData?.sku}
                pageType={'product details page'}
                referrerpage={referrerPage}
                sectionName={isFBTEnabled ? 'Product Details Page - FBT' : 'Product Details Page'}
              />
            </div>
            <ProductOverview detailsData={detailsData} scrollRef={scrollRef} fbtCondition={fbtCondition} />
          </Container>
        )}
        {!loadingProductDetails && detailsData?.sku === undefined && <ProductNotFound />}
        {detailsData && detailsData?.sku !== undefined && (
          <ProductBottom
            detailsData={detailsData}
            catId={catID}
            catLID={catLID}
            catLID_name={catLID_name}
            brandId={customAttribute?.brand}
            setLoading={setLoading}
            skuId={detailsData?.sku}
            referrerPage={referrerPage}
            scrollRef={scrollRef}
            fbtCondition={fbtCondition}
            pdpUpSellingFlag={pdpUpSellingFlag}
            productId={detailsData?.productId}
            setShowVideo={setShowVideo}
            showVideo={showVideo}
            selectedMediaID={selectedMediaID}
            setSelectedMediaId={setSelectedMediaId}
            analyticsProps={commonAnalyticsProps?.current}
            emptySphValues={emptySphValues}
          />
        )}
        {isReviewsEnable === 'true' && detailsData?.sku !== undefined && web_feature_flaging?.isRatingsReviewEnabled && <ProductReviews detailsData={detailsData} />}
        <div ref={ratingsBottomRef} />
      </div>
    </ProductDetailsStyled>
  );
};

ProductDetails.propTypes = {
  setLoading: PropTypes.func,
  productDetails: PropTypes.object,
  productQuery: PropTypes.string,
  homePageSeoData: PropTypes.object,
  setIsFirstCalled: PropTypes.func,
  isFirstCalled: PropTypes.bool,
  referrerPage: PropTypes.string,
};
ProductDetails.defaultProps = {
  setLoading: () => {},
  productDetails: {},
  productQuery: '',
  homePageSeoData: {},
  setIsFirstCalled: () => {},
  isFirstCalled: false,
  referrerPage: '',
};
export default ProductDetails;
